var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ModuleTitle"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"english-title"},[_c('span',[_vm._v(_vm._s(_vm.EnglishTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }